'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AiAddress1 = function (_React$Component) {
    _inherits(AiAddress1, _React$Component);

    function AiAddress1() {
        _classCallCheck(this, AiAddress1);

        return _possibleConstructorReturn(this, (AiAddress1.__proto__ || Object.getPrototypeOf(AiAddress1)).apply(this, arguments));
    }

    _createClass(AiAddress1, [{
        key: 'svgPath',
        value: function svgPath(strokeColor, strokeWidth) {
            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement(
                    'g',
                    { id: 'O0k78E_2_' },
                    _react2.default.createElement(
                        'g',
                        null,
                        _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M14,31.994c0.151-0.181,0.278-0.391,0.456-0.54c1.591-1.333,3.194-2.652,4.789-3.981c2.065-1.721,4.124-3.45,6.189-5.172 c1.61-1.342,3.23-2.67,4.835-4.018c0.942-0.792,2.524-0.795,3.477,0.011c1.739,1.471,3.493,2.924,5.241,4.384 c0.028,0.023,0.061,0.038,0.14,0.087c0.01-0.132,0.024-0.228,0.024-0.325c0.002-1.255,0-2.511,0.002-3.766 c0.001-0.718,0.225-0.936,0.95-0.936c1.275,0,2.549,0,3.824,0c0.699,0,0.929,0.23,0.929,0.931 c0.001,2.856,0.004,5.712-0.005,8.568c-0.001,0.236,0.076,0.392,0.251,0.537c1.477,1.217,2.952,2.435,4.419,3.664 c0.185,0.155,0.321,0.37,0.479,0.558c0,0.134,0,0.268,0,0.403c-0.458,0.561-0.915,1.122-1.373,1.682 c-0.448,0.549-0.793,0.6-1.335,0.155c-1.197-0.984-2.383-1.98-3.573-2.972c-1.219-1.017-2.437-2.036-3.655-3.054 c-1.322-1.103-2.644-2.206-3.966-3.309c-1.293-1.079-2.587-2.156-3.876-3.239c-0.16-0.134-0.277-0.137-0.44,0 c-1.796,1.506-3.596,3.007-5.397,4.508c-1.344,1.121-2.692,2.238-4.036,3.36c-1.197,0.999-2.389,2.003-3.586,3.003 c-0.69,0.576-1.378,1.154-2.077,1.719c-0.511,0.413-0.865,0.374-1.279-0.124c-0.473-0.575-0.938-1.155-1.407-1.731 C14,32.262,14,32.128,14,31.994z' }),
                        _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M34.857,46.31c0-2.876,0-5.708,0-8.554c-1.915,0-3.798,0-5.714,0c0,2.848,0,5.68,0,8.554c-0.135,0-0.237,0-0.338,0 c-2.683,0-5.366,0.001-8.05,0c-1.05,0-1.61-0.56-1.611-1.62c-0.002-3.431,0.001-6.861-0.005-10.292 c0-0.253,0.084-0.415,0.284-0.578c1.985-1.622,3.958-3.258,5.936-4.889c1.225-1.01,2.454-2.016,3.679-3.026 c0.981-0.809,1.958-1.621,2.955-2.446c0.425,0.344,0.841,0.677,1.252,1.016c1.02,0.838,2.038,1.678,3.055,2.518 c1.202,0.993,2.403,1.988,3.606,2.98c1.218,1.004,2.438,2.005,3.657,3.007c0.384,0.316,0.778,0.621,1.141,0.959 c0.099,0.092,0.145,0.285,0.145,0.433c0.01,1.849,0.007,3.699,0.007,5.548c0,1.581,0.001,3.162-0.001,4.744 c-0.001,1.095-0.551,1.646-1.642,1.646c-2.664,0.001-5.328,0-7.992,0C35.118,46.31,35.014,46.31,34.857,46.31z' })
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var strokeColor = this.props.strokeColor || 'white';
            var strokeWidth = this.props.strokeWidth || 0;
            var viewBox = '0 0 64 64';
            var style = {
                fontSize: '200%',
                verticalAlign: '-23%'
            };

            if (this.props.noPad) {
                viewBox = '12 12 40 40';
                style = {};
            }

            var props = _underscore2.default.omit(this.props, 'noPad', 'strokeColor');

            if (this.props.strokeWidth > 0) {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-address-1', viewBox: viewBox, style: style }, props),
                    this.svgPath(strokeColor, strokeWidth),
                    this.svgPath('white', 0)
                );
            } else {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-address-1', viewBox: viewBox, style: style }, props),
                    this.svgPath('white', 0)
                );
            }
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return Object.assign({}, _reactIconBase2.default.propTypes, {
                strokeColor: _propTypes2.default.string,
                strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
                noPad: _propTypes2.default.bool
            });
        }
    }]);

    return AiAddress1;
}(_react2.default.Component);

exports.default = AiAddress1;